@if(detail) {
<tec-detail-layout back backAction="emit" (backEvent)="goBack($event)">
    <div class="layout--60-40">
        <div class="layout__column">
            <tec-item
                [tagImage]="{ icon: 'icon-flow' }"
                [title]="detail.alias"
                [detailAction]="detail.company_name"
                [clickeable]="false"
            >
                <tec-list-detail>
                    <tec-tag-group
                        [tags]="[
                            { size: 'sm', label: ('WORKFLOWS.DETAIL.' + detail.status.toUpperCase()) | translate, status: detail.status === 'active' ? 'success' : 'disabled' },
                            { size: 'sm', label: ( 'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.' + getValidationTypeOpt(detail) ) | translate, type: 'default' }
                        ]"
                    ></tec-tag-group>
                    <app-uuid-flexible-display
                        [uuid]="detail?.uuid"
                        [label]="'WORKFLOWS.DETAIL.ID' | translate"
                    />
                </tec-list-detail>

                @if (canViewDeveloperCurl()) {
                <tec-button-icon
                    icon="icon-code-brackets"
                    type="default"
                    size="sm"
                    (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_DETAIL', profileCurlPath())"
                />
                }

                @if (workflowsHelper.getDetailMenuOpt({ status: detail.status }).length > 0) {
                <tec-menu
                    [options]="workflowsHelper.getDetailMenuOpt({ status: detail.status })"
                    (valueChange)="dataMenuChange($event)"
                >
                    <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
                </tec-menu>
                }
            </tec-item>

            @if (rolePermissions.canViewWorkflowJson() && onlyJson) {
            <app-workflows-detail-json-view [detail]="detail" (dataJsonMenuChange)="dataJsonMenuChange($event)" />
            } @else {
            <app-workflows-detail-view [detail]="detail" />
            }
        </div>

        <div class="layout__column">
            @if (rolePermissions.canLaunchWorkflowDemo() && detail) {
                <tec-card-access
                    [size]="'md'"
                    [title]="'WORKFLOWS.DETAIL.GENERATE_ONE_TIME_LINK' | translate"
                    [tagImage]="{ icon: 'icon-link', status: 'default' }"
                    (click)="openGenerateOneTimeLink()"
                />
            }

            <tec-stats [value]="`${detail.average}s`" [title]="'WORKFLOWS.DETAIL.AVERAGE_TIME' | translate">
                @if (canViewDeveloperCurl()) {
                    <tec-button-icon
                        icon="icon-code-brackets"
                        type="default"
                        size="sm"
                        (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_AVERAGE', profileCurlPath('/average'))"
                    />
                }
            </tec-stats>

            <div class="grid grid-e2">
                <tec-stats
                    size="sm"
                    [value]="`${detail.process?.OK.percent}%`"
                    [title]="'WORKFLOWS.DETAIL.APPROVED' | translate"
                >
                    @if (canViewDeveloperCurl()) {
                        <tec-button-icon
                            icon="icon-code-brackets"
                            type="default"
                            size="sm"
                            (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_APPROVED', profileCurlPath('/approved'))"
                        />
                    }
                </tec-stats>
                <tec-stats
                    size="sm"
                    [value]="`${detail.process?.KO.percent}%`"
                    [title]="'WORKFLOWS.DETAIL.REJECTED' | translate"
                >
                    @if (canViewDeveloperCurl()) {
                        <tec-button-icon
                            icon="icon-code-brackets"
                            type="default"
                            size="sm"
                            (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_REJECTED', profileCurlPath('/rejected'))"
                        />
                    }
                </tec-stats>
                <tec-stats
                    size="sm"
                    [value]="`${detail.process?.CANCELLED.percent}%`"
                    [title]="'WORKFLOWS.DETAIL.ABANDONED' | translate"
                >
                    @if (canViewDeveloperCurl()) {
                        <tec-button-icon
                            icon="icon-code-brackets"
                            type="default"
                            size="sm"
                            (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_ABANDONED', profileCurlPath('/abandoned'))"
                        />
                    }
                </tec-stats>
            </div>

            @if (rolePermissions.canViewWorkflowJson()) {
            <tec-item
                [title]="'PROCESSES.DETAIL.JSON' | translate"
                [tagImage]="{ icon: 'icon-back-ajax-result', status: 'level' }"
                [clickeable]="false"
            >
                <tec-menu [options]="workflowsHelper.detailItemJsonMenuOpt" (valueChange)="dataJsonMenuChange($event)">
                    <tec-button-icon [icon]="'icon-more'" />
                </tec-menu>
            </tec-item>
            }
        </div>
    </div>
</tec-detail-layout>
}

@if (resourceError) {
    <app-detail-resource-error
        [kind]="resourceError.kind"
        [titleKey]="resourceError.titleKey"
        [descriptionKey]="resourceError.descriptionKey"
        [showRetry]="resourceError.kind === 'generic'"
        (backEvent)="goBack($event)"
        (retryEvent)="getDetail()"
    />
}

@if (curlModalOpen()) {
<app-modal-curl-request
    [titleKey]="curlModalTitleKey()"
    [curlText]="curlModalText()"
    (closeEvent)="closeCurlModal()"
/>
}

@if (showModalEdit && rolePermissions.canViewWorkflowJson()) {
    <app-modal-workflow-form [isNewWorkflow]="false" (closeEvent)="closeModalEdit($event)" />
}

@if (showModalJsonEdit && rolePermissions.canViewWorkflowJson()) {
    <app-modal-workflow-json-editor [json]="detail" [canEdit]="canEditModalJsonEdit" (closeEvent)="closeModalJsonEdit($event)" />
}

@if (workflow) {
	<app-modal-create-process [workflow]="workflow" [workflowResponse]="detail" (closeEvent)="workflow = undefined"></app-modal-create-process>
}
